import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, SearchArray, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {TranslationService} from '../../../../translation/Services/translation.service';
import {DomainService} from '../../../../translation/Services/domain-service.service';
import {LanguageService} from '../../../../translation/Services/language.service';
import {TranslationModel} from '../../../../translation/translation.models';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-localization-label',
  templateUrl: './localization-label.component.html',
  styleUrls: ['./localization-label.component.scss']
})
export class LocalizationLabelComponent implements OnInit {

  public grid: Grid;
  public translations: TranslationModel[];
  public adjust: TranslationModel;

  @ViewChild('editAllModal', {static: false}) editAllModal;
  @ViewChild('gridView', {static: false}) gridView;

  constructor(
    private translationService: TranslationService,
    private domainService: DomainService,
    private languageService: LanguageService,
    private translateService: TranslateService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      root: 'translations',
      columns: [
        <NumberColumn>{
          name: 'doctrine.attributes.id',
          prop: 'id',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.attributes.domain',
          prop: 'domain.name',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.attributes.unit',
          prop: 'keyword',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.translation.value',
          prop: 'value',
          sortable: false,
          type: TextColumn.type,
          translate: true
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'icofont icofont-pencil-alt-2',
              onclick: row => this.showEditAllModal(row),
              showCallback: row => row,
              btnClass: 'ripple light'
            }
          ]
        }
      ],
      service: this.translationService,
      rememberURL: this.router.url,
      method: 'list',
      defaultSort: 'name',
      defaultSortType: 'desc',
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          type: 'ng-select',
          hasDropdownListFilter: true,
          hasNormalSearch: true,
          searchArrays: [
            {
              value: {value: [{value: null, label: 'All'}, {value: true, label: 'Not Translated'}]},
              name: 'not_translated',
              label: 'doctrine.attributes.filter',
            }, {
              value: new ServiceSearchItem(this.languageService, 'list', {sortType: 'ASC', sortBy: 'name'}, (res) => res.languages.map(row => ({value: row.id, label: row.name}))),
              name: 'language',
              label: 'doctrine.attributes.language',
              selectedValue: {value: 1, label: 'English'},
            },
            {
              value: new ServiceSearchItem(this.domainService, 'list', {sortType: 'ASC', sortBy: 'name'}, (res) => {
                const options = [];
                for (const row of res.domains) {
                  options.push({value: row.id, label: row.name});
                }
                return options;
              }),
              name: 'domain',
              label: 'doctrine.attributes.domain',
            }
          ],
        }
      ],
    };
  }

  showEditAllModal(row: TranslationModel) {
    this.adjust = row;
    this.editAllModal.show();
    this.translationService.listAll(row).subscribe(data => {
      this.translations = data.translations;
    });
  }

  purgeTranslations() {
    this.languageService.purgeTranslations().subscribe(resp => {
      window.location.reload();
    });
  }

  saveAllModal() {
    this.translationService.updateAll(this.adjust, this.translations).subscribe(res => {
      this.adjust = null;
      this.translations = null;
      this.gridView.sendRequest();
      this.editAllModal.hide();
    });
  }
}
